module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-arrow-up-c47683543e48f57bdaf9de679b859e6f.svg";